import DataTableFooter, { DataTableFooterProps } from "./DataTableFooter";

const ParticipantListFooter = (props: DataTableFooterProps) => (
  <DataTableFooter {...props} showCountLabel />
);

export default ParticipantListFooter;
